import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
// Formatação monetária padrão (pt-BR, 2 casas) — fonte única de verdade para os
// valores de receita exibidos nos cards e no tooltip do heatmap de Horários.
export function formatBRL(value: number): string {
  return (value || 0).toLocaleString(getInterfaceLanguage(), {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
